.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
  padding: 0.8rem;
  border-radius: 0.4rem;
  background-color: var(--color-shades-hibiscus);
}

.end-of-day {
  font-weight: 400;
  font-size: 1.2rem;
  padding: 0.8rem;
}

.time-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  font-weight: 400;
  font-size: 1.2rem;
  color: var(--color-grayscale-ghost);
}
